import { createSlice } from "@reduxjs/toolkit";

const parseBool = (key) => {
  try {
    const localVal = localStorage.getItem(key);
    const sessionVal = sessionStorage.getItem(key);

    if (localVal && localVal !== "undefined" && localVal !== "null") {
      return JSON.parse(localVal);
    } else if (sessionVal && sessionVal !== "undefined" && sessionVal !== "null") {
      return JSON.parse(sessionVal);
    }
  } catch (e) {
    // ignore JSON errors
  }
  return false;
};
const initialAuthState = {
  accessToken: localStorage.getItem("accessToken") || sessionStorage.getItem("accessToken") || null,
  userId: localStorage.getItem("userId") || sessionStorage.getItem("userId") || null,
  refreshToken:
    localStorage.getItem("refreshToken") || sessionStorage.getItem("refreshToken") || null,
  isAuthenticated: !!(localStorage.getItem("accessToken") || sessionStorage.getItem("accessToken")),
  isDistributor: parseBool("isDistributor"),
};

const authSlice = createSlice({
  name: "auth",
  initialState: initialAuthState,
  reducers: {
    login: (state, action) => {
      const { accessToken, userId, refreshToken, isDistributor } = action.payload;
      state.accessToken = accessToken;
      state.userId = userId;
      state.refreshToken = refreshToken;
      state.isAuthenticated = true;
      state.isDistributor = isDistributor;

      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("userId", userId);
      localStorage.setItem("refreshToken", refreshToken);
      localStorage.setItem("isDistributor", isDistributor);

      // if (rememberMe) {
      //   localStorage.setItem("accessToken", accessToken);
      //   localStorage.setItem("refreshToken", refreshToken);
      // } else {
      //   sessionStorage.setItem("accessToken", accessToken);
      //   sessionStorage.setItem("refreshToken", refreshToken);
      // }
    },
    logout: (state) => {
      state.accessToken = null;
      state.refreshToken = null;
      state.isAuthenticated = false;
      state.isDistributor = false;
      sessionStorage.clear();
      localStorage.clear();
    },
    refreshAccessToken: (state, action) => {
      state.accessToken = action.payload;
      localStorage.setItem("accessToken", action.payload);
    },
  },
});

export const { login, logout, refreshAccessToken } = authSlice.actions;
export default authSlice.reducer;
